var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialItunes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 63,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.399 80.987a43.084 43.084 0 0 1-4.267 7.672c-2.244 3.199-4.081 5.413-5.498 6.644-2.194 2.018-4.546 3.053-7.064 3.111-1.808 0-3.987-.515-6.525-1.558-2.546-1.04-4.886-1.554-7.025-1.554-2.244 0-4.65.514-7.224 1.554-2.579 1.043-4.656 1.587-6.243 1.641-2.415.104-4.822-.96-7.224-3.194-1.534-1.338-3.452-3.63-5.75-6.879-2.465-3.468-4.492-7.491-6.08-12.076-1.701-4.953-2.553-9.75-2.553-14.393 0-5.319 1.15-9.907 3.452-13.751 1.809-3.088 4.216-5.524 7.229-7.312 3.012-1.789 6.268-2.7 9.773-2.758 1.917 0 4.433.594 7.559 1.759 3.117 1.169 5.119 1.763 5.996 1.763.656 0 2.88-.694 6.647-2.077 3.563-1.283 6.573-1.814 9.038-1.605 6.677.539 11.694 3.171 15.03 7.914-5.973 3.62-8.928 8.687-8.868 15.189.055 5.064 1.891 9.278 5.503 12.626a18.082 18.082 0 0 0 5.496 3.605 59.299 59.299 0 0 1-1.402 3.679zM80.085 20.721c0 3.97-1.45 7.676-4.341 11.106-3.488 4.078-7.708 6.435-12.283 6.063a12.427 12.427 0 0 1-.092-1.505c0-3.81 1.659-7.888 4.605-11.222 1.472-1.689 3.341-3.093 5.61-4.212 2.264-1.104 4.403-1.713 6.417-1.818.06.531.084 1.061.084 1.588z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialItunes);
export default __webpack_public_path__ + "static/media/social-itunes.9c47108d6704edc2dc4e489459e6dc0d.svg";
export { ForwardRef as ReactComponent };